import { useEffect, useState } from "react";
import { pathName } from "pages/routes";

interface AdminMenu {
    name: string;
    submenu: Array<{ name: string; url: string }>;
}

const menu: AdminMenu[] = [
    {
        name: "adminPanel.label.notifications",
        submenu: [
            {
                name: "adminPanel.label.templateEditor",
                url: pathName.TEMPLATES_OVERVIEW,
            },
            {
                name: "adminPanel.label.emailScheduler",
                url: pathName.SCHEDULER_OVERVIEW,
            },
        ],
    },
    {
        name: "adminPanel.label.mappings",
        submenu: [
            {
                name: "adminPanel.label.creativeMappings",
                url: pathName.CREATIVE_MAPPINGS_OVERVIEW,
            },
        ],
    },
];

interface PanelState {
    panel: AdminMenu[];
    menuItems: Array<{ id: number; isCollapsed: boolean }>;
}

export const useAdminMenu = (searchPhrase: string) => {
    const setInitialState = () => {
        return {
            menuItems: menu.map((item, index) => {
                return {
                    id: index,
                    isCollapsed: false,
                };
            }),
            panel: menu,
        };
    };

    const [sideMenu, setMenuState] = useState<PanelState>(setInitialState());

    const handleMenu = (index: number) => () => {
        setMenuState((state) => ({
            ...state,
            menuItems: state.menuItems.map((item) => {
                if (item.id === index) {
                    return {
                        ...item,
                        isCollapsed: !item.isCollapsed,
                    };
                }

                return item;
            }),
        }));
    };

    useEffect(() => {
        const filterMenuByPhrase = () =>
            menu
                .map((item) => {
                    const filteredSubmenu = item.submenu.filter(({ name }) =>
                        name.toLowerCase().includes(searchPhrase.toLowerCase())
                    );

                    return {
                        ...item,
                        submenu: filteredSubmenu,
                    };
                })
                .filter((item) => item.submenu.length);

        if (searchPhrase) {
            const filteredMenu = filterMenuByPhrase();
            setMenuState({
                menuItems: filteredMenu.map((menu, index) => ({
                    id: index,
                    isCollapsed: false,
                })),
                panel: filteredMenu,
            });

            return;
        }

        setMenuState(setInitialState());
    }, [searchPhrase]);

    return {
        setMenuItems: handleMenu,
        sideMenu,
    };
};
